import {Slider} from "./Slider";
import {MobileSlider} from "./MobileSlider";
import {GameTextData, getTextByLang} from "./Game";
import "./main.css";
import {getLangFromUrl, Header} from "./Header";
import {Hero} from "./Hero";
import {translations} from "./Translations";
import {About} from "./About";
import {Flow} from "./Flow";
import {Footer} from "./Footer";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {AppDispatch, RootState} from "./store/store";
import {fetchGames} from "./store/gamesSlice";


import {useNavigate, useLocation} from 'react-router-dom';
import {Flex, Spin} from "antd";
import {Loading} from "./Loading";

export const useSmartNavigate = () => {
    const navigate = useNavigate();

    const smartNavigate = (path) => {
        // Regex checks if the string starts with a schema (e.g., https://, mailto:)
        const hasSchema = /^[a-z][a-z0-9+.-]*:/i.test(path);

        if (hasSchema) {
            // Navigate to external site
            window.location.href = path;
        } else if (path.startsWith('/')) {
            // Navigate to internal route
            navigate(path);
        } else {
            // Fallback: handle relative paths or log error
            console.warn("Invalid path: Path must have a schema or start with '/'");
        }
    };

    return smartNavigate;
};

export const Main = () => {
    const dispatch = useDispatch<AppDispatch>();
    const games = useSelector((state: RootState) => state.games.list);
    useLocation(); // re-render on URL change so getLangFromUrl() stays in sync
    const lang = getLangFromUrl();
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(fetchGames()).then(() =>
            setLoading(false)
        );
    }, [dispatch]);

    return (
        loading ? <Loading/> :
            <div className={'main ' + (lang === 'he' ? "rtl" : 'ltr')} dir={lang === 'he' ? 'rtl' : 'ltr'}>

                <>
                    <Header/>
                    <Hero game={games.find((g) => g.isHero)} navigation={true}/>
                    {games.filter((d) => d.published && getTextByLang(d.image, lang)).length > 0 &&
                        <div className="games-section">
                            <div className="games-section-title">{translations[lang].our_games}</div>
                            <div className="slider-desktop">
                                <Slider
                                    data={games.filter((d) => d.published)}
                                    activeSlide={games.length / 2}
                                    visibleCount={games.length >= 11 ? 11 : games.length}
                                    containerWidth={1000}
                                    size={{width: 600, height: 400}}
                                    loop
                                    rtl={lang === 'he'}
                                />
                            </div>
                            <div className="slider-mobile">
                                <MobileSlider
                                    data={games.filter((d) => d.published && (d.hero?.image?.length ?? 0) > 0)}
                                    loop
                                    rtl={lang === 'he'}
                                />
                            </div>
                        </div>
                    }
                    <About/>
                    <Flow/>
                    <Footer/></>

            </div>
    );
}